import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectRequestData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.requestData

export const selectRequestLoadingStatus = createSelector(
  [selectRequestData],
  ({ status }) => status
)
